export type TEmptyListProps = {
    title:string
    msg:(string|JSX.Element)[]|string|JSX.Element
}
export default function EmptyList(props:TEmptyListProps){
    return <div className="empty grid center">
        <h1>{props.title}</h1>
        <p>{props.msg}</p>
    </div>
}